import React from 'react'
import styled from 'styled-components'

const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`

const RadioControl = styled.span`
  position: relative;
  display: ${props => props.buttonStyle ? 'none' : 'inline-block'};
  width: 18px;
  height: 18px;
  margin-right: 8px;
  border: 2px solid #666;
  border-radius: 50%;
  transition: all 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${props => props.theme.primary || '#007bff'};
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  ${RadioInput}:checked + & {
    border-color: ${props => props.theme.primary || '#007bff'};
    &::after {
      opacity: 1;
    }
  }

  ${RadioInput}:focus + & {
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  }
`

const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  ${props => props.color && `
    color: ${props.color};
  `}

  svg {
    transition: all 0.2s ease;
    ${props => props.checked && props.buttonStyle && `
      color: ${props.selectedColor || '#007bff'};
      transform: scale(1.1);
    `}
  }
`

const Radio = ({ id, name, value, checked, onChange, label, buttonStyle, color, selectedColor, ...props }) => {
  return (
    <RadioLabel checked={checked} buttonStyle={buttonStyle} color={color} selectedColor={selectedColor}>
      <RadioInput
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <RadioControl buttonStyle={buttonStyle} />
      {label}
    </RadioLabel>
  )
}

export default Radio
